import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertController, ModalController, NavController } from '@ionic/angular';
import { ProducerViewComponent } from 'src/app/components/producer-view/producer-view.component';
import { ProductViewComponent } from 'src/app/components/product-view/product-view.component';
import { MarketModel } from 'src/app/models/market.model';
import { ProductModel } from 'src/app/models/product.model';
import { ProfileModel } from 'src/app/models/profile.model';
import { TourneeModel } from 'src/app/models/tournee.model';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { DataService } from 'src/app/services/data/data.service';
import { HomeService } from 'src/app/services/home-service/home.service';
import { MathService } from 'src/app/services/math/math.service';
import { ProductService } from 'src/app/services/product/product.service';

@Component({
  selector: 'products-list-row',
  templateUrl: './products-list-row.component.html',
  styleUrls: ['./products-list-row.component.scss'],
})
export class ProductsListRowComponent implements OnInit {

  @Input()
  title:string;

  @Input()
  mode:string // edit, view, order, catalog, sale, prepare

  @Input()
  loading:boolean = false;

  @Input()
  items:ProductModel[];

  @Input("tournee")
  set tournee(value: TourneeModel) {
    // console.log('set tournee',value);
    this.setProductArray(value);
    this._tournee = value;
  }

  products:ProductModel[] = []
  productsFiltered:ProductModel[] = []


  @Input('filter')
  set filter(value){
    // console.log('filters',value);
    this._filter = value;
    this.onFilter(value);
  }
  _filter:any = {};
  _tournee:TourneeModel;

  @Input()
  viewer:ProfileModel;

  @Output() quantityChanged = new EventEmitter<ProductModel>();

  @Output() editTournee = new EventEmitter<TourneeModel>();


  constructor(private dataService:DataService, private navCtrl:NavController, private alertCtrl:AlertController, public auth:AuthenticationService, 
    public mathService:MathService, private modalCtrl:ModalController, private productService:ProductService, private homeService:HomeService) {

  }

  ngOnInit(){

  }

  publish(item:ProductModel){
    this.changeProductStatus(item,'published');
  }

  unpublish(item:ProductModel){
    this.changeProductStatus(item,'unpublished');
  }

  setProductArray(tournee:TourneeModel){
    if(tournee.products && tournee.products.references){
      this.products = Object.entries(tournee.products.references)
                      .map(item => <ProductModel>{key:item[0], ...item[1] as {}, tournee:tournee} )
                      .sort(this.productService.sortProduct());
      this.productsFiltered = Object.entries(tournee.products.references)
                      .map(item => <ProductModel>{key:item[0], ...item[1] as {}, tournee:tournee} )
                      .sort(this.productService.sortProduct());        
    }           
  }

  async changeProductStatus(product:ProductModel,status){
    product.status = status;
    this.dataService.updateProductStatus(product);
  } 


  async presentProduct(product:ProductModel,producer:ProfileModel){
    const modal = await this.modalCtrl.create({
      component: ProductViewComponent,
      cssClass: 'shopping-cart',
      componentProps:{
        item:product,
        producer:producer
      }
    });
    return await modal.present();
  }
  async presentProducer(producer:ProfileModel){
    const modal = await this.modalCtrl.create({
      component: ProducerViewComponent,
      cssClass: 'shopping-cart',
      componentProps:{
        producer:producer
      }
    });
    return await modal.present();
  }
  changeProducerRole(market:MarketModel, item:ProfileModel,role){
    item.role = role;
    this.dataService.updateMarketProducerRole(market,item,role)
  }

  clickProducer(item:ProfileModel){
    this.presentProducer(item)
  }

  clickSale(item:TourneeModel){
    this.homeService.navigateToMySale(item);
  }

  clickProduct(item:ProductModel,zone:string){
    if(this.mode == 'order' || this.mode =='owner'){
      this.presentProduct(item,this._tournee.producer)
    }
    else if (this.mode =='sale'){
      if(item.status == 'included'){this.removeToSale(item);}
      else { this.addToSale(item)};
    }
    else if(this.mode == 'catalog'){
      this.addToCatalog(item)
    }
    else if(this.mode =='edit'){
      if(zone==='header'){
        if(item.status == 'published'){this.unpublish(item);}
        else { this.publish(item)};        
      }
      else{
        //this.edit(item);
      }
    }
  }

  addToCatalog(item:ProductModel){

  }

  addToSale(item:ProductModel){
    item.status = 'included';
  }
  removeToSale(item:ProductModel){
    item.status = 'notIncluded';
  }

  onQuantityChanged(quantity,item:ProductModel, tournee:TourneeModel){
    if(!item.basket){item.basket = {}};
    item.basket.quantity = quantity;
    item.basket.totalPriceVATIncluded = this.mathService.calculateProductTotalAmount(item);
    item.basket.totals = this.mathService.calculateProductTotalsAmount(item);
    item.tournee = tournee;
    this.quantityChanged.emit(item);
  }

  onFilter(filter){
    this.productsFiltered = this.productService.filterAndSearch(this.products,filter.keyword, filter.types);
  }

  editManagedProducerTournee(tournee:TourneeModel){
    this.editTournee.emit(tournee);
  }
}
